function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { isArray as z } from "./code-utils.js";

var Oe = /*#__PURE__*/function () {
  function Oe() {
    _classCallCheck(this, Oe);
  }

  _createClass(Oe, [{
    key: "ef",
    value: function ef() {}
  }, {
    key: "ff",
    value: function ff() {}
  }, {
    key: "ec",
    value: function ec(t) {}
  }], [{
    key: "nf",
    value: function nf(t, e) {
      if (t && e) if (t = t.toLowerCase(), z(e.cf)) {
        for (var r = 0; r < e.cf.length; r++) {
          if (-1 !== t.indexOf(e.cf[r].toLowerCase())) return e.identity;
        }
      } else if (-1 !== t.indexOf(e.cf.toLowerCase())) return e.identity;
    }
  }]);

  return Oe;
}();

export { Oe as default };